module.exports = __webpack_public_path__ + "img/microplastics-4.66d02a77.png";